export function normalizarBloques(dl) {
  if (!dl) return [];
  if (typeof dl === 'string') return [{ type: 'text', content: dl }];
  if (Array.isArray(dl)) {
    return dl.map(item => {
      if (typeof item === 'string') return { type: 'text', content: item };
      if (item.imagen) return { type: 'image', url: item.imagen };
      return item;
    });
  }
  return [];
}
